require.context("../images", true);
import "entrypoints/decidim_dev.scss";
import "src/decidim/dev/accessibility";
window.Decidim = window.Decidim || {};
window.Decidim.dev = true;
